// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-2Hqh8","info":"info-2qvRU","copy":"copy-38gx0"};